import React, { useEffect } from 'react';
import { useAuth } from 'auth/AuthContext';
import KskTooltip from 'ksk/styledComponents/components/KskPopover/KskTooltip';
import logoPNG from 'ksk/assets/template/siconfi-no-subtitle-dark-blue.png';
import smallLogoPNG from 'ksk/assets/template/siconfi-no-subtitle-dark-blue-small.png';
import { ReactComponent as LibrasIcon } from 'ksk/assets/template/libras-logo-vector.svg';
import { ReactComponent as RestApiIcon } from "../../../ksk/assets/svg-logos/api.svg";
import BuscaRapidaIdSiconfi from 'pages/id_siconfi/BuscaRapidaIdSiconfi';
import Credenciais from './Credenciais';
import MainMenu from '../MainMenu/MainMenu';
import ScrollTop from '../ScrollTop/ScrollTop';
import useWindowSize from 'ksk/hooks/useWindowSize';
import { useMatch, useNavigate } from "react-router";
import { openVLibras } from 'utils/vlibras';

function MainHeader() {
  const navigate = useNavigate();
  const isSelectingVinculo = useMatch('/usuario-vinculos/');

  useEffect(() => {
    if (window.core && window.core.BRHeader) {
      const brHeader = document.querySelector('.br-header');
      new window.core.BRHeader('br-header', brHeader);
    }
  }, []);

  const { isPhone } =  useWindowSize();

  const { credentials, reverseSignOn, isAuthenticated } = useAuth();

  return (
    <>
      <header className="br-header" style={{zIndex: 1000}} data-sticky={true}>
        <div className="container-fluid">
          <div className="header-top">
            <div className="header-logo">
              {isAuthenticated ? (
                <KskTooltip title="Selecionar módulo do sistema"
                  body="Encerra a sessão no módulo Operações de Crédito e vai para a página de seleção de módulos na Área Administrativa." popover arrow>
                  <button className="header__logo" type="button" onClick={reverseSignOn} style={{ border: 'none', background: 'transparent' }}>
                    <img src={isPhone ? smallLogoPNG : logoPNG} alt="logo" style={{ marginLeft: "8px" }} />
                  </button>
                </KskTooltip>) :
                <img src={isPhone ? smallLogoPNG : logoPNG} alt="logo" style={{ marginLeft: "8px" }} />}
            </div>
            <div className="header-actions">
              <div className="header-links dropdown">
                <button className="br-button circle small" type="button" data-toggle="dropdown"
                  aria-label="Abrir Acesso Rápido">
                  <i className="fas fa-ellipsis-v" aria-hidden="true"></i>
                </button>
                <div className="br-list">
                  <div className="header">
                    <div className="title">Acesso Rápido</div>
                  </div>
                  <a className="br-item" href="https://www.gov.br/secom/pt-br/acesso-a-informacao/comunicabr" target="_blank" rel="noopener noreferrer">ComunicaBR</a>
                  <a className="br-item" href="https://www.gov.br/acessoainformacao/pt-br" target="_blank" rel="noopener noreferrer">Acesso a Informação</a>
                  <a className="br-item" href="https://www.gov.br/pt-br/participacao-social/" target="_blank" rel="noopener noreferrer">Participe</a>
                  <a className="br-item" href="http://www4.planalto.gov.br/legislacao/" target="_blank" rel="noopener noreferrer">Legislação</a>
                  <a className="br-item" href="https://www.gov.br/pt-br/orgaos-do-governo" target="_blank" rel="noopener noreferrer">Órgãos do Governo</a>
                </div>
              </div>
              <span className="br-divider vertical mx-half mx-sm-1"></span>
              <div className="header-functions dropdown">
                <button className="br-button circle small" type="button" data-toggle="dropdown"
                  aria-label="Abrir Funcionalidades do Sistema">
                    <i className="fas fa-th" aria-hidden="true"></i>
                </button>
                <div className="br-list">
                  {/* <div className="br-item">
                        <button className="br-button circle small" type="button" aria-label="Alto contraste">
                            <i className="fas fa-adjust" aria-hidden="true"></i>
                            <span className="text">Alto contraste</span>
                        </button>
                    </div>
                    <div className="br-item">
                        <button className="br-button circle small" type="button" aria-label="Modo Escuro">
                            <i className="fas fa-moon" aria-hidden="true"></i>
                            <span className="text">Modo Escuro</span>
                        </button>
                    </div> */}
                  <div className="br-item">
                    <a className="br-button circle small"
                      href="https://e-servicos.tesouro.gov.br/#/public/homeUsuario/Area/266361"
                      aria-label="Fale conosco"
                      title="Fale conosco"
                      target="_blank"
                      rel="noopener noreferrer">
                      <i className="fas fa-headset" aria-hidden="true"></i>
                      <span className="text">Fale conosco</span>
                    </a>
                  </div>
                  <div className="br-item">
                    <a className="br-button circle small"
                      href="https://manuais.tesouro.gov.br/oc_cdp"
                      aria-label="Manual de operações de crédito e CDP"
                      title="Manual de operações de crédito e CDP"
                      target="_blank"
                      rel="noopener noreferrer">
                      <i className="fas fa-book" aria-hidden="true"></i>
                      <span className="text">Manual de operações de crédito e CDP</span>
                    </a>
                  </div>
                  <div className="br-item">
                    <a
                      className="br-button circle small"
                      href="#"
                      aria-label="Catálogo de APIs"
                      title="Catálogo de APIs"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate('/catalogo-api');
                      }}
                    >
                      <RestApiIcon className="icon" aria-hidden="true" />
                      <span className="text">Catálogo de APIs</span>
                    </a>
                  </div>
                  <div className="br-item">
                    <a
                      className="br-button circle small"
                      aria-label="VLibras"
                      title="VLibras"
                      onClick={openVLibras}
                    >
                      <LibrasIcon className="icon" aria-hidden="true" alt="VLibras" />
                      <span className="text">VLibras</span>
                    </a>
                  </div>
                </div>
              </div>
              {isAuthenticated &&
              <div className="header-search-trigger">
                <button className="br-button circle" type="button" aria-label="Abrir Busca" data-toggle="search"
                  data-target=".header-search">
                  <i className="fas fa-search" aria-hidden="true"></i>
                </button>
              </div>}
              <div className="header-login d-flex">
                <Credenciais className="header__credenciais" credentials={credentials} />
              </div>
            </div>
          </div>
          <div className="header-bottom">
            <div className="header-menu">
              {!isSelectingVinculo && <div className="header-menu-trigger">
                <button className="br-button small circle" type="button" aria-label="Menu" data-toggle="menu"
                  data-target="#main-navigation" id="navigation">
                    <i className="fas fa-bars" aria-hidden="true"></i>
                </button>
              </div>}
              <div className="header-info" style={{ marginLeft: "2px", paddingTop: "0" }}>
                <div className="header-title">Operações de crédito e CDP</div>
              </div>
            </div>
            {isAuthenticated && 
            <div className="header-search">
              <BuscaRapidaIdSiconfi />
              <button className="br-button circle search-close ml-1" type="button" aria-label="Fechar Busca" data-dismiss="search">
                <i className="fas fa-times" aria-hidden="true"></i>
              </button>
            </div>}
          </div>
        </div>
        {!isSelectingVinculo && <MainMenu />}
        <ScrollTop />
      </header>
    </>
  )
}

export default MainHeader;
